import { render, staticRenderFns } from "./NoteThreadForm.vue?vue&type=template&id=1d019310&"
import script from "./NoteThreadForm.vue?vue&type=script&lang=ts&"
export * from "./NoteThreadForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports